import classNames from 'classnames';
import type { JSX, MouseEvent, ReactNode } from 'react';
import './Tabs.css';
import { Button } from '@ipfabric/ui-components/Button/Button';

export interface Tab<TKey> {
  label: ReactNode;
  key: TKey;
  disabled?: boolean;
}

export interface TabsProps<TKey> {
  className?: string;
  tabs: readonly Tab<TKey>[];
  onChangeTab: (tab: TKey) => void;
  selected: TKey | null;
  variant: 'compact' | 'bookmark';
  showAddButton?: boolean;
  onAddTabClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const Tabs = <TKey extends string = string>(
  props: TabsProps<TKey>,
): JSX.Element => (
  <div
    className={classNames('tabs', `tabs--${props.variant}`, props.className)}
  >
    {props.tabs.map((tab) => (
      <button
        type='button'
        className={classNames(
          'tabs__tab',
          `tabs__tab--${props.variant}`,
          props.selected === tab.key && 'tabs__tab--selected',
        )}
        key={tab.key}
        onClick={() => {
          props.onChangeTab(tab.key);
        }}
        disabled={tab.disabled}
      >
        {tab.label}
      </button>
    ))}
    {props.showAddButton && (
      <Button
        onClick={props.onAddTabClick}
        icon='fa-plus'
        renderAs='button'
        variant='plain'
        size='default'
        className='ml-0.5 self-center'
      >
        New tab
      </Button>
    )}
  </div>
);
